import { useCallback } from 'react';

export const useIncludeInTotalConversionHandler = updateDraftEvent => {
    const handleIncludeInTotalChange = useCallback(
        selected => {
            updateDraftEvent(draft => ({ ...draft, includeInTotalConversions: selected }));
        },
        [updateDraftEvent]
    );

    const handleSelectCheckbox = useCallback(() => handleIncludeInTotalChange(true), [handleIncludeInTotalChange]);
    const handleUnselectCheckbox = useCallback(() => handleIncludeInTotalChange(false), [handleIncludeInTotalChange]);

    return {
        handleSelectCheckbox,
        handleUnselectCheckbox,
    };
};
